import type {
  PaymentDocSubscriptionCallback,
  PaymentDocSubscriptionErrorCallback,
  PaymentsRepository,
} from '../repositories/payments-repository';

/**
 * Inscreve em tempo real em `payments/{paymentId}` validando `user_id`.
 */
export class SubscribePaymentDocForUserUseCase {
  constructor(private readonly repository: PaymentsRepository) {}

  execute(
    paymentId: string,
    userId: string,
    onNext: PaymentDocSubscriptionCallback,
    onError: PaymentDocSubscriptionErrorCallback
  ): () => void {
    return this.repository.subscribeByIdForUser(paymentId, userId, onNext, onError);
  }
}
